import React from 'react'

const Creative = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="59"
      height="59"
      viewBox="0 0 59 59"
    >
      <g>
        <g>
          <path
            fill="#f96cad"
            d="M0 5a5 5 0 0 1 5-5h49a5 5 0 0 1 5 5v49a5 5 0 0 1-5 5H5a5 5 0 0 1-5-5z"
          />
        </g>
        <g>
          <g>
            <path
              fill="#fff"
              d="M50.423 42.817a2.352 2.352 0 0 1-2.35 2.35H8.917a2.352 2.352 0 0 1-2.35-2.35v-2.35h43.857zm-16.777 8.616H23.364l1.764-4.7h6.754zM50.36 14.03c.05.192.074.39.074.588V38.9H6.567V14.617a2.353 2.353 0 0 1 2.35-2.35H9.7v25.066h1.567V9.917a2.353 2.353 0 0 1 2.35-2.35h29.766c.198 0 .396.024.588.074l.391-1.517A3.922 3.922 0 0 0 43.383 6H13.617A3.921 3.921 0 0 0 9.7 9.917v.783h-.783A3.921 3.921 0 0 0 5 14.617v28.2a3.921 3.921 0 0 0 3.917 3.916h14.536l-1.763 4.7h-1.807V53h17.234v-1.567H35.31l-1.763-4.7h14.536A3.921 3.921 0 0 0 52 42.817v-28.2c0-.33-.041-.66-.124-.979z"
            />
          </g>
          <g>
            <path fill="#fff" d="M45.55 19.82h.922v17.51h-.922z" />
          </g>
          <g>
            <path fill="#fff" d="M14.22 9.69h.922v.922h-.922z" />
          </g>
          <g>
            <path fill="#fff" d="M16.98 9.69h.922v.922h-.922z" />
          </g>
          <g>
            <path fill="#fff" d="M19.75 9.69h.922v.922h-.922z" />
          </g>
          <g>
            <path
              fill="#fff"
              d="M13.29 13.228v23.327c0 .43.35.777.783.777H43.84a.78.78 0 0 0 .783-.777V24.114h-1.566v5.12l-2.58-2.56-1.108 1.1 3.688 3.66v4.343h-28.2v-4.25l6.266-4.146 1.916 1.268.869-1.294-2.35-1.556a.788.788 0 0 0-.87 0l-5.831 3.86V14.005H36.79V12.45H14.073a.78.78 0 0 0-.783.778z"
            />
          </g>
          <g>
            <path
              fill="#fff"
              d="M22.508 22.762a2.933 2.933 0 0 1-2.932-2.934 2.933 2.933 0 0 1 2.932-2.934 2.933 2.933 0 1 1 0 5.868zm0 1.674a4.608 4.608 0 1 0 0-9.216 4.608 4.608 0 0 0 0 9.216z"
            />
          </g>
          <g>
            <path
              fill="#fff"
              d="M48.818 7.782c.4-.293.954-.251 1.304.098.351.349.393.9.099 1.298l-7 9.453a29.36 29.36 0 0 1-6.233 6.215l-3.916-3.897a29.366 29.366 0 0 1 6.246-6.202zm-18.55 21.75l-.502-.125a1.156 1.156 0 0 1-.88-1.122 2.734 2.734 0 0 0-1.725-2.545 4.523 4.523 0 0 1 1.129-.616l1.99-.743 3.303 3.29-.484 1.926a4.456 4.456 0 0 1-.88 1.747 2.764 2.764 0 0 0-1.95-1.812zm-5.404 3.44c.496-.96.687-2.045.55-3.114a4.423 4.423 0 0 1 .556-2.772l.354.058c.562.091.974.574.972 1.139a2.739 2.739 0 0 0 2.091 2.657l.503.125c.435.11.77.457.858.893l.101.499a4.517 4.517 0 0 1-2.098.514zm7.283-10.7l3.51 3.494c-.35.229-.703.452-1.063.666L31.48 23.33c.215-.358.438-.71.668-1.057zm-4.417 1.366a6.033 6.033 0 0 0-3.9 6.421 3.761 3.761 0 0 1-1.086 3.155.791.791 0 0 0-.173.864c.123.297.413.49.736.49h5.438a6.068 6.068 0 0 0 5.9-4.586l.513-2.04a30.949 30.949 0 0 0 9.34-8.37l6.996-9.453a2.577 2.577 0 0 0-.254-3.362 2.605 2.605 0 0 0-3.377-.253L38.37 13.47a30.91 30.91 0 0 0-8.433 9.344z"
            />
          </g>
          <g>
            <path
              fill="#fff"
              d="M41.865 17.67l-1.14-1.53c-.553.418-1.1.857-1.625 1.306l1.23 1.459c.495-.424 1.012-.84 1.535-1.234z"
            />
          </g>
          <g>
            <path
              fill="#fff"
              d="M36.71 21.666a27.903 27.903 0 0 1 2.386-2.503l-1.158-1.183a29.56 29.56 0 0 0-2.528 2.652z"
            />
          </g>
        </g>
      </g>
    </svg>
  )
}

export default Creative
